// Combined search tracking event names
export var ACTIVITIES_COMBINED_SEARCH_FOCUSED = "activities_combined_search_focused";
export var ACTIVITIES_COMBINED_SEARCH_TYPED = "activities_combined_search_typed";
export var ACTIVITIES_COMBINED_SEARCH_RESULT_CLICKED = "activities_combined_search_result_clicked";
export var ACTIVITIES_COMBINED_SEARCH_RECENT_CLICKED = "activities_combined_search_recent_clicked";
export var ACTIVITIES_COMBINED_SEARCH_CLEARED = "activities_combined_search_cleared";
export var ACTIVITIES_COMBINED_SEARCH_NO_RESULTS = "activities_combined_search_no_results";
export var CombinedSearchResultType;
(function (CombinedSearchResultType) {
    CombinedSearchResultType["Destination"] = "destination";
    CombinedSearchResultType["Category"] = "category";
    CombinedSearchResultType["Attraction"] = "attraction";
    CombinedSearchResultType["Product"] = "product";
    CombinedSearchResultType["Collection"] = "collection";
    CombinedSearchResultType["Trip"] = "trip";
    CombinedSearchResultType["RecentSearch"] = "recent_search";
})(CombinedSearchResultType || (CombinedSearchResultType = {}));
export var ActivitiesEntryTypeEnum;
(function (ActivitiesEntryTypeEnum) {
    ActivitiesEntryTypeEnum["HOMEPAGE"] = "activities_homepage";
    ActivitiesEntryTypeEnum["AVAILABILITY"] = "activities_availability";
    ActivitiesEntryTypeEnum["ACTIVITIES_XSELL"] = "activities_xsell_view_all";
    ActivitiesEntryTypeEnum["ACTIVITIES_XSELL_CARD"] = "activities_xsell_card";
    ActivitiesEntryTypeEnum["STAYS_XSELL"] = "stays_xsell_view_all";
    ActivitiesEntryTypeEnum["STAYS_XSELL_CARD"] = "stays_xsell_card";
    ActivitiesEntryTypeEnum["TRAVEL_SALE_LANDING"] = "travel_sale_landing";
    ActivitiesEntryTypeEnum["UPCOMING_TRIP"] = "upcoming_trip";
    ActivitiesEntryTypeEnum["RECENTLY_SEARCHED"] = "recently_searched";
    ActivitiesEntryTypeEnum["SIMILAR_ACTIVITIES"] = "similar_activities";
    ActivitiesEntryTypeEnum["COMBINED_SEARCH_DESTINATION"] = "combined_search_destination";
    ActivitiesEntryTypeEnum["COMBINED_SEARCH_CATEGORY"] = "combined_search_category";
    ActivitiesEntryTypeEnum["COMBINED_SEARCH_ATTRACTION"] = "combined_search_attraction";
    ActivitiesEntryTypeEnum["COMBINED_SEARCH_PRODUCT"] = "combined_search_product";
    ActivitiesEntryTypeEnum["MYTRIPS_XSELL_FLIGHT"] = "mytrips_xsell_flight";
    ActivitiesEntryTypeEnum["MYTRIPS_XSELL_STAY"] = "mytrips_xsell_stay";
    ActivitiesEntryTypeEnum["MYTRIPS_XSELL_ACTIVITY"] = "mytrips_xsell_activity";
    ActivitiesEntryTypeEnum["MYTRIPS_XSELL"] = "mytrips_xsell";
})(ActivitiesEntryTypeEnum || (ActivitiesEntryTypeEnum = {}));
export var ExperiencesSelectionEnum;
(function (ExperiencesSelectionEnum) {
    ExperiencesSelectionEnum["ExperiencesDestination"] = "Destination";
})(ExperiencesSelectionEnum || (ExperiencesSelectionEnum = {}));
export var ActivitiesSelectionEnum;
(function (ActivitiesSelectionEnum) {
    ActivitiesSelectionEnum["ActivitiesDestination"] = "Destination";
})(ActivitiesSelectionEnum || (ActivitiesSelectionEnum = {}));
export var ExperiencesAvailabilityRequestEnum;
(function (ExperiencesAvailabilityRequestEnum) {
    ExperiencesAvailabilityRequestEnum["FollowupSearch"] = "FollowupSearch";
    ExperiencesAvailabilityRequestEnum["InitialSearch"] = "InitialSearch";
    ExperiencesAvailabilityRequestEnum["RequestParams"] = "RequestParams";
})(ExperiencesAvailabilityRequestEnum || (ExperiencesAvailabilityRequestEnum = {}));
export var TripadvisorRatingRefinement;
(function (TripadvisorRatingRefinement) {
    TripadvisorRatingRefinement["Any"] = "Any";
    TripadvisorRatingRefinement["Great"] = "Great";
    TripadvisorRatingRefinement["VeryGood"] = "VeryGood";
    TripadvisorRatingRefinement["Good"] = "Good";
})(TripadvisorRatingRefinement || (TripadvisorRatingRefinement = {}));
export var DurationRefinement;
(function (DurationRefinement) {
    DurationRefinement["LessThanOneHour"] = "LessThanOneHour";
    DurationRefinement["MoreThanOneDay"] = "MoreThanOneDay";
    DurationRefinement["OneToFourHours"] = "OneToFourHours";
    DurationRefinement["UpToOneDay"] = "UpToOneDay";
})(DurationRefinement || (DurationRefinement = {}));
export var StartTimeRefinement;
(function (StartTimeRefinement) {
    StartTimeRefinement["Afternoon"] = "Afternoon";
    StartTimeRefinement["EveningAndNight"] = "EveningAndNight";
    StartTimeRefinement["Morning"] = "Morning";
})(StartTimeRefinement || (StartTimeRefinement = {}));
export var PopularFeaturesFilterRefinement;
(function (PopularFeaturesFilterRefinement) {
    PopularFeaturesFilterRefinement["BadgeOfExcellence"] = "BadgeOfExcellence";
    PopularFeaturesFilterRefinement["FreeCancellation"] = "FreeCancellation";
    PopularFeaturesFilterRefinement["LikeyToSellOut"] = "LikeyToSellOut";
    PopularFeaturesFilterRefinement["AvailableToday"] = "AvailableToday";
    PopularFeaturesFilterRefinement["WheelchairAccess"] = "WheelchairAccess";
    PopularFeaturesFilterRefinement["FamilyFriendly"] = "FamilyFriendly";
    PopularFeaturesFilterRefinement["AdultsOnly"] = "AdultsOnly";
})(PopularFeaturesFilterRefinement || (PopularFeaturesFilterRefinement = {}));
export var ExperiencesAvailabilitySort;
(function (ExperiencesAvailabilitySort) {
    ExperiencesAvailabilitySort["DurationAscending"] = "DurationAscending";
    ExperiencesAvailabilitySort["DurationDescending"] = "DurationDescending";
    ExperiencesAvailabilitySort["LodgingCrossSell"] = "LodgingCrossSell";
    ExperiencesAvailabilitySort["LodgingCrossSellOnlyUniversal"] = "LodgingCrossSellOnlyUniversal";
    ExperiencesAvailabilitySort["PriceAscending"] = "PriceAscending";
    ExperiencesAvailabilitySort["PriceDescending"] = "PriceDescending";
    ExperiencesAvailabilitySort["Rating"] = "Rating";
    ExperiencesAvailabilitySort["Recommended"] = "Recommended";
})(ExperiencesAvailabilitySort || (ExperiencesAvailabilitySort = {}));
export var ExperiencesCancellationSummary;
(function (ExperiencesCancellationSummary) {
    ExperiencesCancellationSummary["FreeCancellation"] = "FreeCancellation";
    ExperiencesCancellationSummary["PaidCancellation"] = "PaidCancellation";
})(ExperiencesCancellationSummary || (ExperiencesCancellationSummary = {}));
export var ExperiencePricingCategoryEnum;
(function (ExperiencePricingCategoryEnum) {
    ExperiencePricingCategoryEnum["PerGroup"] = "PerGroup";
    ExperiencePricingCategoryEnum["PerPerson"] = "PerPerson";
})(ExperiencePricingCategoryEnum || (ExperiencePricingCategoryEnum = {}));
export var TicketType;
(function (TicketType) {
    TicketType["MobileOnly"] = "MobileOnly";
    TicketType["Paper"] = "Paper";
    TicketType["Unknown"] = "Unknown";
})(TicketType || (TicketType = {}));
/**
 * The number of tickets per booking, e.g. one per booking or one per traveler
 * @export
 * @enum {string}
 */
export var TicketsPerBooking;
(function (TicketsPerBooking) {
    TicketsPerBooking["OnePerBooking"] = "OnePerBooking";
    TicketsPerBooking["OnePerTraveler"] = "OnePerTraveler";
    TicketsPerBooking["Unknown"] = "Unknown";
})(TicketsPerBooking || (TicketsPerBooking = {}));
export var ExperienceBadge = {
    BadgeOfExcellence: "BadgeOfExcellence",
    FreeCancellation: "FreeCancellation",
    LikelyToSellOut: "LikelyToSellOut",
};
export var ExperienceItineraryEnum;
(function (ExperienceItineraryEnum) {
    ExperienceItineraryEnum["ExperienceItineraryActivities"] = "Activities";
    ExperienceItineraryEnum["ExperienceItineraryHopOnHopOff"] = "HopOnHopOff";
    ExperienceItineraryEnum["ExperienceItineraryMultiDayTour"] = "MultiDayTour";
    ExperienceItineraryEnum["ExperienceItineraryStandard"] = "Standard";
    ExperienceItineraryEnum["ExperienceItineraryUnstructured"] = "Unstructured";
})(ExperienceItineraryEnum || (ExperienceItineraryEnum = {}));
export var ExperiencesAgeBandEnum;
(function (ExperiencesAgeBandEnum) {
    ExperiencesAgeBandEnum["ADULT"] = "Adult";
    ExperiencesAgeBandEnum["CHILD"] = "Child";
    ExperiencesAgeBandEnum["INFANT"] = "Infant";
    ExperiencesAgeBandEnum["SENIOR"] = "Senior";
    ExperiencesAgeBandEnum["TRAVELER"] = "Traveler";
    ExperiencesAgeBandEnum["YOUTH"] = "Youth";
})(ExperiencesAgeBandEnum || (ExperiencesAgeBandEnum = {}));
/**
 * Type of language guide
 * @export
 * @enum {string}
 */
export var ExperienceLanguageGuideTypeEnum;
(function (ExperienceLanguageGuideTypeEnum) {
    ExperienceLanguageGuideTypeEnum["Audio"] = "Audio";
    ExperienceLanguageGuideTypeEnum["Human"] = "Human";
    ExperienceLanguageGuideTypeEnum["Written"] = "Written";
})(ExperienceLanguageGuideTypeEnum || (ExperienceLanguageGuideTypeEnum = {}));
/**
 * How are reviews sorted
 * @export
 * @enum {string}
 */
export var ExperiencesShopReviewsSort;
(function (ExperiencesShopReviewsSort) {
    ExperiencesShopReviewsSort["Newest"] = "Newest";
    ExperiencesShopReviewsSort["RatingsHighToLow"] = "RatingsHighToLow";
    ExperiencesShopReviewsSort["RatingsLowToHigh"] = "RatingsLowToHigh";
})(ExperiencesShopReviewsSort || (ExperiencesShopReviewsSort = {}));
/**
 * Filter reviews by rating
 * @export
 * @enum {string}
 */
export var ExperiencesShopReviewRatingRefinement;
(function (ExperiencesShopReviewRatingRefinement) {
    ExperiencesShopReviewRatingRefinement["Good"] = "Good";
    ExperiencesShopReviewRatingRefinement["Great"] = "Great";
    ExperiencesShopReviewRatingRefinement["VeryGood"] = "VeryGood";
})(ExperiencesShopReviewRatingRefinement || (ExperiencesShopReviewRatingRefinement = {}));
export var FoodAndDrinkTypeEnum = {
    AlcoholicBeverages: "AlcoholicBeverages",
    BottledWater: "BottledWater",
    Breakfast: "Breakfast",
    CoffeeAndTea: "CoffeeAndTea",
    Dinner: "Dinner",
    Lunch: "Lunch",
    Refreshments: "Refreshments",
    Snacks: "Snacks",
    SodaPop: "SodaPop",
};
export var FoodCourseEnum = {
    Dessert: "Dessert",
    Main: "Main",
    Starter: "Starter",
};
/**
 * Data type required for the answer to the question
 * @export
 * @enum {string}
 */
export var BookingQuestionDataType = {
    Date: "Date",
    LocationRefOrFreeText: "LocationRefOrFreeText",
    NumberAndUnit: "NumberAndUnit",
    String: "String",
    Time: "Time",
};
export var BookingQuestionId = {
    Ageband: "Ageband",
    DateOfBirth: "DateOfBirth",
    DisembarkationTime: "DisembarkationTime",
    FullNamesFirst: "FullNamesFirst",
    FullNamesLast: "FullNamesLast",
    Height: "Height",
    PassportExpiry: "PassportExpiry",
    PassportNationality: "PassportNationality",
    PassportPassportNo: "PassportPassportNo",
    PickupPoint: "PickupPoint",
    SpecialRequirements: "SpecialRequirements",
    TransferAirArrivalAirline: "TransferAirArrivalAirline",
    TransferAirArrivalFlightNo: "TransferAirArrivalFlightNo",
    TransferAirDepartureAirline: "TransferAirDepartureAirline",
    TransferAirDepartureFlightNo: "TransferAirDepartureFlightNo",
    TransferArrivalDropOff: "TransferArrivalDropOff",
    TransferArrivalMode: "TransferArrivalMode",
    TransferArrivalTime: "TransferArrivalTime",
    TransferDepartureDate: "TransferDepartureDate",
    TransferDepartureMode: "TransferDepartureMode",
    TransferDeparturePickup: "TransferDeparturePickup",
    TransferDepartureTime: "TransferDepartureTime",
    TransferPortArrivalTime: "TransferPortArrivalTime",
    TransferPortCruiseShip: "TransferPortCruiseShip",
    TransferPortDepartureTime: "TransferPortDepartureTime",
    TransferRailArrivalLine: "TransferRailArrivalLine",
    TransferRailArrivalStation: "TransferRailArrivalStation",
    TransferRailDepartureLine: "TransferRailDepartureLine",
    TransferRailDepartureStation: "TransferRailDepartureStation",
    Weight: "Weight",
};
/**
 * if the question is required, optional or conditional
 * @export
 * @enum {string}
 */
export var BookingQuestionRequired = {
    Conditional: "Conditional",
    Mandatory: "Mandatory",
    Optional: "Optional",
};
/**
 * per person or per group
 * @export
 * @enum {string}
 */
export var BookingQuestionGroup = {
    PerBooking: "PerBooking",
    PerTraveler: "PerTraveler",
};
/**
 * Type of the pickup location. `Location` is when the location is a specific address added by the supplier
 * @export
 * @enum {string}
 */
export var PickupLocationType = {
    Airport: "Airport",
    Hotel: "Hotel",
    Location: "Location",
    Port: "Port",
};
export var ActivitiesCancelScenarioEnum;
(function (ActivitiesCancelScenarioEnum) {
    ActivitiesCancelScenarioEnum["AlreadyCanceled"] = "AlreadyCanceled";
    ActivitiesCancelScenarioEnum["BookingPending"] = "BookingPending";
    ActivitiesCancelScenarioEnum["CancellationPending"] = "CancellationPending";
    ActivitiesCancelScenarioEnum["ContactCustomerService"] = "ContactCustomerService";
    ActivitiesCancelScenarioEnum["FullyRefundable"] = "FullyRefundable";
    ActivitiesCancelScenarioEnum["NonCancellable"] = "NonCancellable";
    ActivitiesCancelScenarioEnum["NonRefundable"] = "NonRefundable";
    ActivitiesCancelScenarioEnum["PartiallyRefundable"] = "PartiallyRefundable";
    ActivitiesCancelScenarioEnum["PastActivityStart"] = "PastActivityStart";
})(ActivitiesCancelScenarioEnum || (ActivitiesCancelScenarioEnum = {}));
export var ResponseEnum;
(function (ResponseEnum) {
    ResponseEnum["Failure"] = "Failure";
    ResponseEnum["Pending"] = "Pending";
    ResponseEnum["Success"] = "Success";
})(ResponseEnum || (ResponseEnum = {}));
/**
 * Status of the booking hold
 * @export
 * @enum {string}
 */
export var BookingHoldStatusType = {
    HoldNotProvided: "HoldNotProvided",
    Holding: "Holding",
    Unknown: "Unknown",
};
//# sourceMappingURL=interfaces.js.map